import Typography from "../Typography";
import style from "./style.module.scss";

export type ButtonBaseProps = {
  text: string;
};

export default function ButtonBase({
  children,
  variant = "primary",
  enabled = true,
  size = "wide",
  type = "button",
  capitalize = false,
  text = "",
  onClick,
  id,
  baseColor = "orange",
  width,
}: {
  children?: JSX.Element;
  text?: string;
  type?: "button" | "submit" | "reset";
  variant?: "primary" | "secondary" | "tertiary";
  capitalize?: boolean;
  size?: "wide" | "modal" | "half" | "action" | "primary";
  enabled?: boolean;
  onClick?: () => void;
  id?: string;
  baseColor?: "orange" | "blue";
  width?: string | number;
}): JSX.Element {
  const handleClick = () => {
    onClick?.();
  };
  const buttonVar = `button--${variant}-${enabled ? "enabled" : "disabled"}${
    baseColor === "orange" ? "" : "-blue"
  }`;
  const buttonSize = `button--${size}`;

  return (
    <button
      id={id}
      data-testid="button"
      type={type}
      style={!enabled ? { cursor: "default", width } : { width }}
      onClick={enabled ? () => handleClick() : (e) => e.preventDefault()}
      className={`${style.button} ${style[buttonVar]} ${style[buttonSize]} `}
    >
      {children}
      <Typography
        variant={"subtitle-4-bold"}
        align="center"
        color={
          !enabled
            ? "light60"
            : variant === "primary"
            ? "white"
            : baseColor === "blue"
            ? "blue80"
            : "orange1"
        }
      >
        {capitalize ? text?.toUpperCase() : text}
      </Typography>
    </button>
  );
}
